export default "__VITE_ASSET__C5KJ4RDZ__"